import { FilePdfOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar/Navbar.tsx';
import { type CredentialType, useMyPasswords } from '../../fetchHooks/useMyPasswords.ts';
import { useUserProfile } from '../../fetchHooks/useUserProfile';
import { exportPasswordsToPDF } from '../../utils/exportPasswordsToPDF';
import { CreatePasswordModal } from './CreatePasswordModal.tsx';
import { EditPasswordModal } from './EditPasswordModal.tsx';
import { ModuleAccessDenied, MyPasswordsTable } from './MyPasswordsTable.tsx';
import styles from './myPasswords.module.css';

const MyPasswords = () => {
  const { t } = useTranslation();
  const { data: user, isLoading: isLoadingUser, userHasServicePasswords } = useUserProfile();
  const { data: passwords, refetch, isLoading: isLoadingPasswords } = useMyPasswords();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditMydayModal, setShowEditMydayModal] = useState<CredentialType | undefined>(undefined);
  const [searchInput, setSearchInput] = useState('');

  const isLoading = isLoadingPasswords || isLoadingUser;
  if (!isLoading && !userHasServicePasswords) {
    return <ModuleAccessDenied />;
  }
  return (
    <div>
      <Navbar />
      <div className="app-container">
        {user?.firstname ? (
          <h2>
            {user?.firstname}'s {t('passwords.title')}
          </h2>
        ) : (
          <h2>
            {t('passwords.title')} {t('common.loading')}
          </h2>
        )}
        <div>
          <div
            style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'left',
              flexDirection: 'row',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <Button disabled={isLoading} type="primary" onClick={() => setShowCreateModal(true)}>
              {t('passwords.createPassword')}
            </Button>
            <Button
              disabled={isLoading || !passwords || passwords.length === 0}
              icon={<FilePdfOutlined />}
              onClick={() => {
                if (passwords) {
                  exportPasswordsToPDF(passwords, user?.firstname);
                }
              }}
            >
              {t('passwords.exportToPDF')}
            </Button>
            <div>
              <Input
                placeholder={t('common.search')}
                className={styles.searchInput}
                value={searchInput}
                type="text"
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </div>
          </div>
          <MyPasswordsTable
            passwords={
              passwords?.filter?.(
                ({ website, comment }) =>
                  website.toLowerCase().includes(searchInput.toLowerCase()) ||
                  comment.toLowerCase().includes(searchInput.toLowerCase()),
              ) || []
            }
            isLoading={isLoading}
            refetch={refetch}
            setShowEditMydayModal={setShowEditMydayModal}
          />
        </div>

        <CreatePasswordModal
          show={showCreateModal}
          onCancel={() => setShowCreateModal(false)}
          onOk={() => {
            setShowCreateModal(false);
            refetch();
          }}
        />
        <EditPasswordModal
          show={!!showEditMydayModal}
          onCancel={() => setShowEditMydayModal(undefined)}
          onOk={() => {
            setShowEditMydayModal(undefined);
            refetch();
          }}
          credential={showEditMydayModal as CredentialType}
        />
      </div>
    </div>
  );
};

export default MyPasswords;
